/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, { Component } from "react";
import "./categoryInfo.css"
import PropTypes from "prop-types";
// import img from "./56da836bN8241f9c4.png"
import { Icon, Modal, Button,Divider  } from "antd";

export default class CategoryInfo extends Component {
    // 默认属性
    static defaultProps = {
        name: 'sASasASas',
        time: "2333333333",
    };
    // 静态类型分析
    static propTypes = {
        aiType: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        time: PropTypes.string.isRequired,
        checked: PropTypes.bool.isRequired,
    };
    constructor(props) {
        super(props)
        this.state = {
            isChecked: false,
            settingVisible: false
        }
    }
    singleChecked = () => {
        this.setState({
            isChecked: !this.state.isChecked
        })
    }
    showSetModal = () => {this.setState({settingVisible: true})};
    setOk = e => {this.setState({settingVisible: false,});
    };

    setCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };
    render() {
        return (
            <div style={{ width: "304px", height: "150px", margin: "15px auto", position: "relative",backgroundColor:'white'}} >
                <div className={this.state.isChecked ? "circleChecked" : "circle"} onClick={this.singleChecked}>
                    <Icon type="check" style={{ color: "#fff", marginLeft: "2px", marginBottom: "2px" }} />
                </div>
                <div style={{display:'flex'}}>
                    <div>
                        <img src='/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality' style={{width:'60px',height:'60px',objectFit:'cover',margin:'20px 16px 20px 20px',borderRadius:'5px'}}/>
                    </div>
                    <div style={{width:'100%',marginRight:'21px'}} >
                        <div style={{display:'flex',marginTop:24,justifyContent:'space-between'}}>
                            <div style={{fontSize: '15px',color:'#333333'}}>11111</div>
                            <div style={{fontSize:'12px',color:'#0050B3',cursor:'pointer'}} onClick={this.showSetModal}>设置</div>
                        </div>
                        <div style={{display:'flex',marginTop:10,justifyContent:'space-between',fontSize:'12px',color:'#999999'}}>
                            <div>赵老师</div>
                            <div>1111111111111111111111</div>
                        </div>
                    </div>
                 </div>
                <Divider  style={{margin:0}}/>
                <div className="aiType">
                    <div></div>
                    <div>AI类型</div>
                </div>
                        <Modal
                            title="设置"
                            visible={this.state.settingVisible}
                            onOk={this.setOk}
                            onCancel={this.setCancel}
                            width="814px"
                            bodyStyle={{ height: "504px", backgroundColor: "#f2f2f2" }}
                            footer={null}
                        >
                            <div style={{ width: "750px", height: "383px", backgroundColor: "#ffffff", margin: "0 auto" }}>
                                <table></table>
                                <div style={{ display: "flex", marginLeft: "34px", marginTop: "31px" }}>
                                    <div style={{ width: "60px", height: "60px" }}>
                                        <img style={{ width: "60px", height: "60px", borderRadius: "5px", objectFit: "cover", minHeight: "100%" }} src='/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality' alt="" />
                                    </div>
                                    <div className="exchangeIcon">更换图标</div>
                                </div>
                                <div className="CateGoryTable">
                                    <table>
                                        <tr ><span> 分类名称:</span><Divider  style={{margin:0}}/></tr>
                                        <tr><span>账号名称:</span><Divider  style={{margin:0}}/></tr>
                                        <tr style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}><div style={{ marginLeft: "11px" }}>管理账号:</div>
                                            <div className="clickModify">点击修改</div>
                                        </tr>
                                        <Divider  style={{margin:0}}/>
                                        <tr><span>分类信息描述:</span></tr>
                                    </table>
                                </div>
                            </div>

                            <div style={{ margin: "20px 300px" }}>
                                <Button type="primary" onClick={this.setOk}>确定</Button>
                                <Button style={{ margin: "10px" }} onClick={this.setCancel}>取消</Button>
                            </div>
                        </Modal>
                </div>

        );
    }
}
